import { BrowserCacheLocation, Configuration, LogLevel } from "@azure/msal-browser";

export const environment = {
  production: false,
  envIdentifier: 'dev',
  rawBaseUrl: 'https://localhost:5010/',
};
